const getParentNodes = (node, path) => {
  path = path || [];

  const { parentNode } = node;

  if (!parentNode) {
    return path;
  }

  return getParentNodes(parentNode, path.concat(parentNode));
};

const getEventPath = (event) => {
  if (event.path) {
    return event.path;
  }

  if (event.composedPath) {
    return event.composedPath();
  }

  return getParentNodes(event.target);
};

window.onload = () => {
  const docs = [...document.querySelectorAll('.docs-names .doc-name')]
  const activeDoc = docs.find((doc) => location.href.includes(doc.getAttribute('href').replace('.html', '')))
  const select = document.querySelector('.docs-select');
  const docsContainer = document.querySelector('.docs-names');

  activeDoc.classList.add('active');
  select.querySelector('.selected-doc').innerHTML = activeDoc.innerText
  document.querySelector('.docs-select').onclick = () => docsContainer.classList.toggle('opened')
  window.onclick = (event) => {
    const path = getEventPath(event);
    const isOutsideClick = !path.includes(document.querySelector('.links-wrapper'));

    if (isOutsideClick) {
      docsContainer.classList.remove('opened')
    }
  }
}
